// src/components/modalForm/LazyLoading.js
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

const LazyLoading = ({ items = [], batchSize = 200, resetKey = '', children }) => {
    const containerRef = useRef(null);
    const [loadingState, setLoadingState] = useState({ resetKey, visibleCount: batchSize });

    const visibleCount = loadingState.resetKey === resetKey
        ? loadingState.visibleCount
        : batchSize;

    useEffect(() => {
        setLoadingState({ resetKey, visibleCount: batchSize });

        if (containerRef.current) {
            containerRef.current.scrollTop = 0;
        }
    }, [batchSize, resetKey]);

    const loadMore = useCallback(() => {
        setLoadingState((currentState) => {
            const currentVisibleCount = currentState.resetKey === resetKey
                ? currentState.visibleCount
                : batchSize;

            return {
                resetKey,
                visibleCount: Math.min(currentVisibleCount + batchSize, items.length),
            };
        });
    }, [batchSize, items.length, resetKey]);

    const handleScroll = useCallback((event) => {
        const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
        const reachedEnd = scrollHeight - scrollTop - clientHeight <= 120;

        if (reachedEnd && visibleCount < items.length) {
            loadMore();
        }
    }, [items.length, loadMore, visibleCount]);

    const visibleItems = useMemo(
        () => items.slice(0, visibleCount),
        [items, visibleCount]
    );

    return children({
        containerRef,
        handleScroll,
        visibleItems,
        hasMore: visibleCount < items.length,
    });
};

export default LazyLoading;
